import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { useLayoutDispatch, popupNotification } from "context/LayoutContext";
import { receiveContainer } from "api/purchase";

export default function ReceiveModal({ containerId, open, onClose }) {
  const layoutDispatch = useLayoutDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    setIsLoading(true);
    receiveContainer({
      id: containerId,
      responseSetter: (res) => {
        setIsLoading(false);
        if (res.success) {
          popupNotification({
            dispatch: layoutDispatch,
            message: "Container received successfully",
            status: "success",
          });
          onClose(true);
        } else {
          popupNotification({
            dispatch: layoutDispatch,
            message: res.message || "Failed to receive container",
            status: "error",
          });
        }
      },
    });
  };

  return (
    <Dialog
      open={open}
      onClose={() => !isLoading && onClose(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Receive Container</DialogTitle>
      <DialogContent>
        <Typography>
          Items will be created on OBT DOCK. Do you want to receive this
          container?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(false)}
          color="primary"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="secondary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={24} /> : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
